import { filter } from 'lodash'
import { combineReducers } from 'redux'
import { loadingReducer } from 'redux-foundry'
import { API_LISTAR_ESTACAO_METEOROLOGICA,
  API_CRIAR_ESTACAO_METEOROLOGICA,
  API_EXCLUIR_ESTACAO_METEOROLOGICA,
  API_ATUALIZAR_ESTACAO_METEOROLOGICA } from 'store/modules/api/estacoesMeteorologicas.actions'

const lista = (state = [], { type, payload }) => {
  switch (type) {
    case API_LISTAR_ESTACAO_METEOROLOGICA.success:
      return payload.sort((a, b) => a.nome.localeCompare(b.nome))
    case API_CRIAR_ESTACAO_METEOROLOGICA.success:
      return [...state, payload].sort((a, b) => a.nome.localeCompare(b.nome))
    case API_ATUALIZAR_ESTACAO_METEOROLOGICA.success:
      return state.map((e) => (e.id === payload.id ?
        payload : e))
    case API_EXCLUIR_ESTACAO_METEOROLOGICA.success:
      return filter(state, (o) => o.id !== Number(payload))
    default: return state
  }
}

const isCarregandoLista = loadingReducer(false, API_LISTAR_ESTACAO_METEOROLOGICA)

const isSaving = loadingReducer(false, API_CRIAR_ESTACAO_METEOROLOGICA)
const isUpdate = loadingReducer(false, API_ATUALIZAR_ESTACAO_METEOROLOGICA)

export default combineReducers({
  lista,
  isCarregandoLista,
  isSaving,
  isUpdate,
})
